module.exports = __webpack_public_path__ + "img/spongebob.65f1a908.jpg";